export default __webpack_public_path__ + "static/4-2e3d96d9fe0d55641b6fe7efcca868d5.png";